// ===========This URl Block Shift In Production .env So  don't change in this file for create builds===Change IP In Production File only=================================

// local IP
// export const BASE_URL = "http://hwaceri5:8077/api/";

// VPS Server URI below
// export const BASE_URL = "http://srv957718.hstgr.cloud:8072/api/";

// hostiger URl
//  export const BASE_URL = "https://portalapp.ahilyanagarsamwadsetu.com/api/";


// HTTPS IP below
// export const BASE_URL = "https://194.238.17.55/api/";

// =============================================================

 export const BASE_URL = process.env.REACT_APP_BASE_URL;
